<template>
  <a-modal title="导入信息"
           :width="800"
           :visible="visible"
           :maskClosable="false"
           @ok="handleUpload"
           @cancel="$emit('cancel')"
           destroyOnClose
           :confirmLoading="itemLoading"
  >
    <div align="right" style="padding-right: 5px;padding-bottom: 5px;margin-top: -20px;">
      <a-button icon="download" @click="downloadTemplate">模板下载</a-button>&nbsp;&nbsp;&nbsp;&nbsp;
    </div>
    <a-row>
      <a-form :form="form" class="pick-100 form-input about">
        <a-col :xs="{ span: 23, offset: 1 }" :lg="{ span: 23, offset: 1 }">
          <a-form-item label="导入文件">
            <a-upload :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload">
              <a-button>
                <a-icon type="upload"/>
                选择
              </a-button>
            </a-upload>
          </a-form-item>
        </a-col>
      </a-form>
    </a-row>
    <br>
  </a-modal>
</template>

<script>
import ProcessSelector from '@/components/workflow/ProcessSelector'
import qs from 'qs'

export default {
  name: 'expertImportModal',
  components: {
    ProcessSelector
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
  },
  created () {
    this.form.resetFields()
  },
  data () {
    return {
      status: 1,
      user: this.$ls.get('user'),
      form: this.$form.createForm(this),
      fileList: [],
      file: {},
      loading: false,
      itemLoading: false,
    }
  },
  methods: {
    handleRemove (file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
    },
    beforeUpload (file) {
      // console.log(file)
      if (!file) {
        this.$message.error('请选择导入文件（类型必须是.xls,.xlsx中的一种）')
        return false
      }

      if (!/\.(xls|xlsx)$/.test(file.name)) {
        this.$message.error('导入文件类型必须是.xls,.xlsx中的一种')
        return false
      }
      this.file = file
      this.handleRemove(file)
      this.fileList = [...this.fileList, file]
      return false
    },
    handleUpload () {
      if (!this.file || !this.file.name) {
        this.$message.error('请选择导入文件（类型必须是.xls,.xlsx中的一种）')
        return false
      }

      const that = this
      const formData = new FormData()
      formData.append('file', that.file)

      that.itemLoading = true
      that.$http.post('/api/1/expertmain/expertInfo/upload?status=' + that.status + '&procId=' + that.procId + '&caseTypeId=' + that.$route.query.caseTypeId, formData).then(function (resp) {
        that.itemLoading = false

        if (resp.code === 200) {
          that.$message.success('导入成功')
          that.$emit('success')
        } else {
          that.$message.error('导入失败')
        }
      }).catch(function (result) {
        that.itemLoading = false
        that.$message.error('操作失败')
      })
    },
    downloadTemplate () { // 下载模板
      const aLink = document.createElement('a')
      const params = {
        filepath: 'conf/epp/expert/expertInfoImport_template.xlsx',
        filename: '专家导入模板.xlsx'
      }
      aLink.href = '/zj/api/1/common/excel/download?' + qs.stringify(Object.assign(params))
      aLink.setAttribute('download', '专家导入模板.xlsx') // 设置下载文件名称
      document.body.appendChild(aLink)
      aLink.click()
      document.body.removeChild(aLink)
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .ant-upload-list-item {
  color: #ff0000;
}
</style>
